import { action } from "typesafe-actions";
import { MeoLocaleActionTypes, IMeoLocale } from "./types";

export const fetchMeoLocales = () => action(MeoLocaleActionTypes.FETCH_MEOLOCALES);
export const setMeoLocales = (meoLocales: IMeoLocale[] | undefined) => 
  action(MeoLocaleActionTypes.SET_MEOLOCALES, meoLocales);